module.exports = __webpack_public_path__ + "static/media/perfect.b1350f8a.gif";